import BannerDetailContainer from './BannerDetailContainer';
export default BannerDetailContainer;
